export const DRAFT_STREAM_GRAMMAR_SUPPRESSION_REASON = "draft_stream";

type GrammarSuppressibleEditor = {
  commands?: {
    setGrammarChecksSuppressed?: (suppressed: boolean, reason?: string) => boolean;
  };
} | null | undefined;

type ComparisonEditorsRef = {
  current?: {
    editorA?: GrammarSuppressibleEditor;
    editorB?: GrammarSuppressibleEditor;
  } | null;
} | null | undefined;

export function setDraftGrammarChecksSuppressed(
  editor: GrammarSuppressibleEditor,
  suppressed: boolean
) {
  return (
    editor?.commands?.setGrammarChecksSuppressed?.(
      suppressed,
      DRAFT_STREAM_GRAMMAR_SUPPRESSION_REASON
    ) ?? false
  );
}

export function createDraftGrammarSuppressionRelease({
  editor,
  comparisonEditorsRef,
}: {
  editor: GrammarSuppressibleEditor;
  comparisonEditorsRef?: ComparisonEditorsRef;
}) {
  let released = false;

  return () => {
    if (released) return;
    released = true;

    setDraftGrammarChecksSuppressed(editor, false);
    const comparisonEditors = comparisonEditorsRef?.current;
    setDraftGrammarChecksSuppressed(comparisonEditors?.editorA, false);
    setDraftGrammarChecksSuppressed(comparisonEditors?.editorB, false);
  };
}
